const ANALYTICS_SESSION_COOKIE = 'jeeum_anon';
const NINETY_DAYS_IN_SECONDS = 90 * 24 * 60 * 60;

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') {
    return null;
  }
  const parts = document.cookie.split(';');
  for (const part of parts) {
    const [rawName, ...rest] = part.trim().split('=');
    if (rawName === name) {
      const value = rest.join('=').trim();
      return value.length > 0 ? value : null;
    }
  }
  return null;
}

function randomId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `anon-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

function writeCookie(name: string, value: string): void {
  if (typeof document === 'undefined') {
    return;
  }
  const secure = typeof window !== 'undefined' && window.location.protocol === 'https:'
    ? '; Secure'
    : '';
  document.cookie =
    `${name}=${value}; Max-Age=${NINETY_DAYS_IN_SECONDS}; Path=/; SameSite=Lax${secure}`;
}

export function getAnalyticsSessionId(): string | null {
  return readCookie(ANALYTICS_SESSION_COOKIE);
}

export function getOrCreateAnalyticsSessionId(): string {
  const existing = getAnalyticsSessionId();
  if (existing) {
    return existing;
  }
  const sessionId = randomId();
  writeCookie(ANALYTICS_SESSION_COOKIE, sessionId);
  return sessionId;
}

export function clearAnalyticsSessionForTests(): void {
  if (typeof document === 'undefined') {
    return;
  }
  document.cookie =
    `${ANALYTICS_SESSION_COOKIE}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
}
